import { useState, useEffect } from "react";
import { Tooltip, IconButton } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

import usePlatformLayoutContext from "../../../helpers/contexts/platformLayout";

const CsvEmailDownloadButton = ({ onDownloadBtnClick, tooltip, reset }) => {
  const { activateSnackbar } = usePlatformLayoutContext();

  const [downloadBtnClicked, setDownloadBtnClicked] = useState(false);

  useEffect(() => {
    setDownloadBtnClicked(false);
  }, [reset]);

  const onButtonClick = async () => {
    const { success } = (await onDownloadBtnClick()) || {};
    activateSnackbar({
      message: success
        ? "You should receive an email with your emissions soon."
        : "An error occurred in trying to download your emissions",
      severity: success ? "success" : "error"
    });
    return setDownloadBtnClicked(true);
  };

  return (
    <Tooltip
      title={
        downloadBtnClicked
          ? "You should receive an email with your emissions soon."
          : tooltip
      }
    >
      <span>
        <IconButton disabled={downloadBtnClicked} onClick={onButtonClick}>
          <FontAwesomeIcon icon={faDownload} />
        </IconButton>
      </span>
    </Tooltip>
  );
};
export default CsvEmailDownloadButton;
